import Proxy from './Proxy';

class StoreProxy extends Proxy {

  constructor(parameters = {}) {
    super('api/store', parameters);
  }

  /**
   * 지역 리스트
   * @returns {Promise}
   */
  getAreaList() {
    return this.submit('get', `${this.endpoint}/areas`);
  }

  /**
   * 매장 층 리스트
   * @param storeSeq
   * @returns {Promise}
   */
  findAllStoreFloors(storeSeq) {
    return this.submit('get', `${this.endpoint}/${storeSeq}/store-floors`);
  }

  /**
   * 매장 층 정보
   * @param storeSeq
   * @param storeFloorSeq
   * @returns {Promise}
   */
  findStoreFloorById(storeSeq, storeFloorSeq) {
    return this.submit('get', `${this.endpoint}/${storeSeq}/store-floors/${storeFloorSeq}`);
  }

  /**
   * 점포현황 (층별)
   * @param storeSeq
   * @param storeFloorSeq
   * @returns {Promise}
   */
  getStoreStatus(storeSeq, storeFloorSeq) {
    return this.submit('get', `${this.endpoint}/${storeSeq}/store-floors/${storeFloorSeq}/status`);
  }

  /**
   * 점포현황 (광고)
   * @param storeSeq
   * @param storeFloorSeq
   * @returns {Promise}
   */
  getStoreMediaList(storeSeq, storeFloorSeq) {
    return this.submit('get', `${this.endpoint}/${storeSeq}/store-floors/${storeFloorSeq}/medias`);
  }

  /**
   * 해당 층 광고매체 정보 삭제
   * @param storeSeq
   * @param storeFloorSeq
   * @returns {Promise}
   */
  deleteStoreMediaByFloorSeq(storeSeq, storeFloorSeq) {
    return this.submit('delete', `${this.endpoint}/${storeSeq}/store-floors/${storeFloorSeq}`);
  }

}

export default StoreProxy;
